import React from 'react';
import Header from '../common/header';
import Footer from '../common/footer';
import About1 from '../layout/about/about1';
import RefundPolicyPage from '../layout/refundpolicy/refundpolicypage';


function RefundPolicy(){
    return(
        <div>
            <Header/>
            <br/>
            <RefundPolicyPage></RefundPolicyPage>
            <br/>
            <Footer/>
        </div>
    )
}
export default RefundPolicy;